import { useContext } from "react";
import { UserContext } from "../../context/userContext/UserContext";
import Login from "../../assets/img/svg/login.svg";
import Ajustes from "../../assets/img/svg/ajustes.svg";

const UserConnected = ({ menuPosition, handleLogout }) => {
  const { user } = useContext(UserContext);
  return (
    <div
      className="userConnected"
      style={{
        position: "absolute",
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
        width: "350px",
        minWidth: "240px",
        minHeight: "130px",
        padding: "10px",
        boxSizing: "border-box",
        transform: "translate(-50%, 0)",
        gap: "10px",
      }}
    >
      <div
        className="userConnectedDetails"
        style={{
          paddingBottom: "0.5em",
        }}
      >
        <p style={{ marginBottom: "7px" }}>{user.nombre}</p>
        <p style={{ fontWeight: "700" }}>{user.perfil.descripcion}</p>
      </div>
      <div
        className="userConnectedOptions"
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "8px",
        }}
      >
        <div className="d-flex userConnectedOptionsLine">
          <img src={Ajustes} alt="" />
          <p>Soporte Técnico</p>
        </div>
        <div className="d-flex" onClick={handleLogout}>
          <img src={Login} alt="" />
          <p>Cerrar Sesión</p>
        </div>
      </div>
    </div>
  );
};

export default UserConnected;
